<template>
  <b-modal
    id="nser-reactivate-modal"
    title="Nser Re-Activate"
    hide-footer
    centered
    size="sm"
    @show="resetModal"
    @hide="resetModal"
  >
    <!-- TITLE -->
    <div class="text-center">
      <h3 class="font-weight-bold text-black">NSER RE-ACTIVATE</h3>
    </div>

    <!-- USER NAME -->
    <div class="text-center">
      <p class="text-black font-weight-bold">Name</p>
      <div class="text-black font-weight-bold">
        {{ userData.user.firstName }} {{ userData.user.middleName }}
        {{ userData.user.lastName }} ({{
          userData.gender === "M" ? "Male" : "FeMale"
        }})
      </div>
    </div>

    <!-- SUBTEXT -->
    <p class="text-center text-black">
      Change Details to enable user to sign up<br />
      again to reactivate
    </p>

    <!-- FirstName INPUT -->
    <div class="d-flex mb-1 mt-2">
      <b-input-group size="md">
        <div class="input-group-prepend">
          <div class="input-group-text" style="width: 110px">FirstName:</div>
        </div>
        <b-form-input v-model="form.firstName"></b-form-input>
      </b-input-group>
    </div>

    <!-- LastName INPUT -->
    <div class="d-flex mb-1 mt-2">
      <b-input-group size="md">
        <div class="input-group-prepend">
          <div class="input-group-text" style="width: 110px">LastName:</div>
        </div>
        <b-form-input v-model="form.lastName"></b-form-input>
      </b-input-group>
    </div>

    <!-- EMAIL INPUT -->
    <div class="d-flex mb-1">
      <b-input-group size="md">
        <div class="input-group-prepend">
          <div class="input-group-text" style="width: 110px">Email:</div>
        </div>
        <b-form-input v-model="form.email"></b-form-input>
      </b-input-group>
    </div>

    <!-- MOBILE INPUT -->
    <div class="d-flex mb-1">
      <b-input-group size="md">
        <div class="input-group-prepend">
          <div class="input-group-text" style="width: 110px">Mobile:</div>
        </div>
        <b-form-input v-model="form.phoneNumber"></b-form-input>
      </b-input-group>
    </div>

    <!-- DOB INPUT -->
    <div class="d-flex mb-1">
      <b-input-group size="md">
        <div class="input-group-prepend">
          <div class="input-group-text" style="width: 110px">Dob:</div>
        </div>
        <b-form-input v-model="form.dob"></b-form-input>
      </b-input-group>
    </div>

    <!-- BUTTONS -->
    <div class="d-flex justify-content-between mt-2" style="gap: 12px">
      <b-button
        class="flex-grow-1"
        style="background: #e0e0e0; border: none; color: black"
        @click="$bvModal.hide('nser-reactivate-modal')"
      >
        CANCEL
      </b-button>

      <b-button
        class="flex-grow-1"
        variant="danger"
        @click="handleActivateAccount"
        :disabled="isSubmitting"
      >
        <Spinner v-if="isSubmitting" />
        <template v-else> CONFIRM</template>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import Spinner from "@/@core/components/Spinner.vue";
import useToastHandler from "@/services/toastHandler";
import {
  BModal,
  BButton,
  BInputGroup,
  BFormGroup,
  BFormInput,
} from "bootstrap-vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    BModal,
    BButton,
    BInputGroup,
    BFormGroup,
    BFormInput,
    Spinner,
  },
  data() {
    return {
      form: {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        dob: "",
      },
    };
  },
  watch: {},
  computed: {
    ...mapState("user/detail", [
      "userData",
      "loadingClientProfile",
      "loadingCheckBetstop",
      "isBetstop",
      "loading"
    ]),
    isSubmitting() {
      return this.loadingClientProfile || this.loadingCheckBetstop || this.loading;
    },
  },
  methods: {
    ...mapActions({
      fetchUser: "user/detail/asyncUser",
      checkBetstop: "user/detail/checkBetstop",
      updateClientProfile: "user/detail/updateClientProfile",
    }),
    resetModal() {
      this.form = {
        firstName: this.userData.user.firstName,
        lastName: this.userData.user.lastName,
        email: this.userData.user.email,
        phoneNumber: this.userData.user.phoneNumber,
        dob: this.userData.user.dob.slice(0, 10),
      };
    },
    async handleActivateAccount() {
      const resUpdate = await this.updateClientProfile({
        userId: this.$router.currentRoute.params.id,
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        email: this.form.email,
        phoneNumber: this.form.phoneNumber,
        dob: this.form.dob,
      });
      if (typeof resUpdate === "boolean" && !!resUpdate) {
        const res = await this.checkBetstop(
          this.$router.currentRoute.params.id
        );
        if (res && res.verified && typeof res.verified === "boolean") {
          await this.updateClientProfile({
            userId: this.$router.currentRoute.params.id,
            isActive: true,
          });
          this.fetchUser({ id: this.$router.currentRoute.params.id });
          this.$bvModal.hide("nser-reactivate-modal");
        }
      }
    },
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();
    return {
      showToastError,
      showToastSuccess,
    };
  },
};
</script>
